import router from '../../router'
import FaqService from '../../services/FaqService'

const state = () => ({
    loadingFaqs: false,
    faq: null,
    faqs: [],
    total: 0,
    pages: 0,
    page: 1,
    show_modal_new_faq: false
})
  
const mutations = {
    SET_FAQ: (state, payload) => {
        state.faq = payload
    },
    SET_FAQS: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.faqs = payload.itens
        }else{
            state.faqs = [...state.faqs, ...payload.itens]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total

    },
    SET_LOADING_FAQS: (state, payload) => {
        state.loadingFaq = payload
    },
}

const actions = {
    async fetchFaq({commit}, id){
        try{
            commit('SET_LOADING_FAQS', true)
            const response = await FaqService.getOne(id);
            commit('SET_FAQ', response.data.item)
            commit('SET_LOADING_FAQS', false)
        } catch (error) {
            commit('SET_LOADING_FAQS', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchFaqs({commit}, params = {}){
        try{
            commit('SET_LOADING_FAQS', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'ASC' } } = params;
            const response = await FaqService.get(keyword, pageNumber, pageSize, order);
            commit('SET_FAQS', response.data)
            commit('SET_LOADING_FAQS', false)
        } catch (error) {
            commit('SET_LOADING_FAQS', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createFaq({commit}, data){
        try{
            commit('SET_LOADING_FAQS', true)
            const response = await FaqService.create(data);
            commit('SET_ALERT', { heading: 'success', message: response.data.message });
            commit('SET_LOADING_FAQS', false)
            return response.data.item;
        } catch (error) {
            commit('SET_LOADING_FAQS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updateFaq({commit}, data){
        try{
            commit('SET_LOADING_FAQS', true)
            const response = await FaqService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_FAQS', false)
        } catch (error) {
            commit('SET_LOADING_FAQS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async deleteFaq({ commit }, id) {
        try {
            const response = await FaqService.delete(id);
            commit('SET_ALERT', { heading: 'success', message: response.message });
        } catch (error) {
            commit('SET_ALERT', { heading: 'error', message: error.response?.data?.message || 'Erro ao excluir FAQ' });
            throw error;
        }
    }
}

const getters = {
    getFaq: state => state.faq,
    getFaqs: state => state.faqs,
    getLoadingFaq: state => state.loadingFaq,
    getShowModalNewFaq: state => state.show_modal_new_faq
}

export default {
    state,
    getters,
    mutations,
    actions
};